import React, { useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

import { useNotify } from 'src/context/ContextNotify';
import { getAPI } from 'src/utils/api';
import { getToken, getUserLogged } from 'src/utils/auth';

const defaultForm = {
  caseid: 0,
  discount: 0,
  discountid: null,
  doctorid: null,
  duration: null,
  memo: '',
  normal_only: false,
  note: '',
  patient_select: null,
  patientid: '',
  person: null,
  quotedate: null,
  quoteid: null,
  status: 1,
  title: '',
  typeid: null,
  quotenumber: null,
  patientname: '',
  campaigncode: '',
};

type DataFormType = {
  caseid: number;
  discount: number | null;
  discountid: number | null;
  doctorid: number | null;
  duration: number | null;
  memo: string;
  normal_only: boolean;
  note: string;
  patient_select: number | null;
  patientid: string;
  person: number | null;
  quotedate: string | null;
  quoteid: number | null;
  status: number | null;
  title: string;
  typeid: number | null;
  quotenumber: number | null;
  patientname: string;
  campaigncode: string | null;
};

interface DialogDetailProps {
  open: boolean;
  patientId: number;
  counselingId: number;
  onClose: (isRefreshList?: boolean) => void;
  onSave?: () => void;
  onDelete?: (data: any | undefined) => void;
}

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const notifyContext = useNotify();
  const [dataForm, setDataForm] = useState<DataFormType>(defaultForm);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleClose = () => {
    props.onClose();
  };

  const setDataEdit = (data: any) => {};

  const getDataDetail = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      setIsLoading(true);
      getAPI(
        `/counseling?patientid=${props.patientId}&counselingId=${props.counselingId}&token=${token}`
      )
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            // Is edit
            if (props.counselingId !== 0) {
              setDataEdit(res.data);
            } else {
              const userLogin = getUserLogged();
              if (userLogin && userLogin.user && userLogin.user.id) {
                setDataForm((prevState) => ({
                  ...prevState,
                  person: userLogin.user.id,
                }));
              }
            }

            setIsLoading(false);
          }
          if (res.code === 403 || res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error',
            });
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleSave = () => {
    console.log('save', dataForm);

    // if (!validate() || !validateItems() || !validateItems('products')) {
    //   return;
    // }
    // try {
    //   const token = getToken();

    //   if (!token) {
    //     throw new Error('Failed to get access token');
    //   }

    //   const data = {
    //     ...dataForm,
    //     items: filterItem(),
    //   };

    //   postAPI(`/patient/save-quote?&token=${token}`, data)
    //     .then((res: any) => {
    //       if (res.code === 200) {
    //         props.onClose(true);
    //       }
    //       if (res.code === 501 || res.code === 500) {
    //         notifyContext.setNotifyMessage({
    //           show: true,
    //           message: res.msg,
    //           type: 'error',
    //         });
    //       }
    //     })
    //     .finally(() => {});
    // } catch (error) {
    //   console.error('Failed to fetch data:', error);
    //   throw error;
    // }
  };

  useEffect(() => {
    if (props.open) {
      getDataDetail();
    } else {
      setDataForm(defaultForm);
    }
    // eslint-disable-next-line
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '1020px',
          m: '0px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '24px', pb: '0px' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography
            sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}
          >
            新規見積
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='Close'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 10px 24px 24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          overflow: 'hidden',
        }}
      >
        <SimpleBar
          style={{ height: 'calc(100vh - 210px)', borderWidth: '18px' }}
        >
          <Stack spacing='10px' sx={{ pr: '14px' }}>
            Form
          </Stack>
        </SimpleBar>
      </DialogContent>

      <DialogActions
        style={{
          padding: '16px',
        }}
      >
        <Stack direction={'row'} spacing={'8px'}>
          <BtnOutlineGradient
            text='キャンセル'
            handleButtonClick={handleClose}
            disabled={isLoading}
          />
          <BtnGradient
            text='登録'
            handleButtonClick={handleSave}
            disabled={isLoading}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDetail;
